import { configureStore } from '@reduxjs/toolkit';

import { eventsReducer } from './events';
import { ledgerReducer } from './ledger';
import { ordersReducer } from './orders';
import { paymentsReducer } from './payments';
import { uiReducer } from './ui';
import { userReducer } from './user';

const store = configureStore({
  reducer: {
    ordersData: ordersReducer,
    eventsData: eventsReducer,
    paymentsData: paymentsReducer,
    ledgerData: ledgerReducer,
    user: userReducer,
    ui: uiReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
